import DeepSwitch from './DeepSwitch'

export default DeepSwitch
